export default function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.debugPanel)+'"> <div class="'+(props.styles.closeButton)+'" data-hook="debug-panel-close-button" > x </div> <pre class="'+(props.styles.infoContainer)+'" data-hook="debug-panel-info-container" > </pre></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/debug-panel/templates/debug-panel.dot
// module id = 126
// module chunks = 0 1 2 3 4